import {
  requestWorkLogEditing,
  RequestWorkLogEditingRequest
} from "../../../services/workLog";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";
import { QUERY_WORK_LOG } from "../queries/useQueryWorkLog";
import { QUERY_WORK_LOGS } from "../queries/useQueryWorkLogs";
import { QUERY_WORK_LOGS_SUMMARY } from "../queries/useQueryWorkLogsSummary";
import { QUERY_LIST_RESOURCE_EVENTS } from "../../resourceEvents/queries/useQueryListEvents";

export const useMutationRequestWorkLogEditing = () =>
  useWSMutation<
    Awaited<ReturnType<typeof requestWorkLogEditing>>,
    WSServiceError,
    RequestWorkLogEditingRequest
  >(request => requestWorkLogEditing(request), {
    dependencies: [
      QUERY_WORK_LOG,
      QUERY_WORK_LOGS,
      QUERY_WORK_LOGS_SUMMARY,
      QUERY_LIST_RESOURCE_EVENTS
    ]
  });
